var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutlinedCheck = function SvgOutlinedCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.333C10.8 3.333 3.334 10.8 3.334 20c0 9.2 7.466 16.667 16.666 16.667S36.667 29.2 36.667 20C36.667 10.8 29.2 3.333 20 3.333Zm0 30C12.65 33.333 6.667 27.35 6.667 20 6.667 12.65 12.65 6.667 20 6.667c7.35 0 13.334 5.983 13.334 13.333 0 7.35-5.984 13.333-13.334 13.333Zm6.467-19.516-9.8 9.8-3.134-3.134a1.66 1.66 0 0 0-2.35 0c-.65.65-.65 1.7 0 2.35L15.5 27.15c.65.65 1.7.65 2.35 0l10.983-10.983c.65-.65.65-1.7 0-2.35a1.68 1.68 0 0 0-2.366 0Z",
    fill: "#6D6D6D"
  })));
};
export default SvgOutlinedCheck;